var map = {
	"./LOGO.png": 8297,
	"./blog.png": 9151,
	"./blogbg.png": 5547,
	"./bubbles.gif": 6096,
	"./client.png": 8033,
	"./clientbg.png": 6166,
	"./cross.png": 4377,
	"./facebook.png": 6463,
	"./foot.png": 3041,
	"./full-menu.png": 7554,
	"./gmail.png": 8578,
	"./harsh.jpg": 4113,
	"./introbg.png": 7965,
	"./karan.jpg": 9365,
	"./kbc.png": 1038,
	"./ketan.jpg": 2575,
	"./ketanconsultancy.png": 8041,
	"./linkedin.png": 8518,
	"./litigation-service.webp": 9330,
	"./main.png": 5530,
	"./menu.png": 3325,
	"./nonlitigation-service.jpg": 428,
	"./practice.png": 2732,
	"./practicesub.png": 1554,
	"./pradeep.jpg": 8617,
	"./prapti.jpg": 4863,
	"./product1.png": 9337,
	"./product2.png": 6101,
	"./product3.png": 1836,
	"./productbg.png": 7279,
	"./raveen.jpg": 3878,
	"./sachin.jpg": 6011,
	"./sambhaji.jpg": 869,
	"./sanjay.jpg": 3761,
	"./search-icon.png": 674,
	"./team.png": 2029,
	"./team1.png": 1413,
	"./team2.png": 3542,
	"./twitter.png": 6737,
	"./vipul.jpg": 2384,
	"./vishal.jpg": 7109,
	"./whatsappicon.png": 8469,
	"./yash.jpg": 2349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;